import { useState, useEffect } from 'react';
import '../../entrydoor.css';

// Pleated screen types. `id` matches frameData.selectedDoor.id used by the
// pleated_screen_template / priceRules and the drawing (1 = single, 2 = double).
export const SCREEN_TYPES = [
    { id: 1, value: 'Single', label: 'Single Leaf (max. 3m or 118")', minW: 20, maxW: 118, minH: 20, maxH: 125 },
    { id: 2, value: 'Double', label: 'Double Leaf (max. 6m or 236")', minW: 30, maxW: 236, minH: 20, maxH: 125 },
];

export const getScreenType = (value) =>
    SCREEN_TYPES.find(t => t.value === value) || SCREEN_TYPES[0];

// `allowedTypes` (array of values, e.g. ['Single']) limits the options a profile supports.
const ScreenType = ({ value, onChange, id = 'ScreenType', label = 'Screen Type', disabled = false, allowedTypes = null }) => {
    const [selectedType, setSelectedType] = useState(value?.value || '');
    const options = allowedTypes ? SCREEN_TYPES.filter(t => allowedTypes.includes(t.value)) : SCREEN_TYPES;

    useEffect(() => {
        setSelectedType(value?.value || '');
    }, [value?.value]);

    // Trigger initial onChange once when component mounts
    useEffect(() => {
        if (!selectedType) {
            const defaultOption = SCREEN_TYPES[0];
            setSelectedType(defaultOption.value);
            onChange({ value: defaultOption.value, label: defaultOption.label });
        }
    }, []);

    const handleTypeChange = (e) => {
        const option = getScreenType(e.target.value);
        setSelectedType(option.value);
        onChange({ value: option.value, label: option.label });
    };

    return (
        <div className="a-container">
            <label htmlFor={id} disabled={disabled}>
                {label}
            </label>
            <select
                disabled={disabled}
                id={id}
                value={selectedType}
                onChange={handleTypeChange}
            >
                {options.map(option => (
                    <option key={option.id} value={option.value}>
                        {selectedType === option.value ? `${option.label} ✔` : option.label}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default ScreenType;
